import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EquipmentComponentizationService} from '../shared/equipment-componentization.service';
import {ComponentizedEquipment} from '../shared/componentized-equipment.model';

@Component({
  templateUrl: './equipment-decomponentization-form-dialog.component.html'
})
export class EquipmentDecomponentizationFormDialogComponent {

  parentItem: ComponentizedEquipment;
  submitMessage: string;
  submitError = false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
              private dialogRef: MatDialogRef<EquipmentDecomponentizationFormDialogComponent>,
              private equipmentComponentizationService: EquipmentComponentizationService) {
    this.parentItem = data.equipment;
  }

  decomponentizeEquipment() {
    this.equipmentComponentizationService.decomponentizeEquipment(this.parentItem.equipId)
      .subscribe(response => {
        if (response && response.error) {
          this.submitMessage = 'Failed to de-componentize the asset. Please try again or contact Tech Support for further assistance.';
          this.submitError = true;
        } else {
          this.submitMessage = 'Successfully de-componentize the asset!';
          this.submitError = false;
        }
      });
  }

  tryAgain() {
    this.submitMessage = null;
    this.submitError = false;
  }

  done() {
    this.dialogRef.close('Done');
  }

  close() {
    if (this.submitError) {
      this.dialogRef.close('Cancel');
    } else {
      this.done();
    }
  }
}
